import { Pipe, PipeTransform } from '@angular/core';
import { Link } from './link.interface';

@Pipe({
  name: 'allow'
})
export class AllowPipe implements PipeTransform {

  transform(links: Link[], allowLinks: any): Link[] {
    return links.filter(link => allowLinks[link.name]);
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/menu/allow.pipe.ts